import { render } from "./SelectCaseCategory.vue?vue&type=template&id=af604ff8&scoped=true"
import script from "./SelectCaseCategory.vue?vue&type=script&lang=js"
export * from "./SelectCaseCategory.vue?vue&type=script&lang=js"

import "./SelectCaseCategory.vue?vue&type=style&index=0&id=af604ff8&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af604ff8"]])

export default __exports__